/**
 * Review units display preferences (pilot: localStorage).
 */

export const UNIT_SYSTEMS = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};

const DEFAULTS = {
  unitSystem: UNIT_SYSTEMS.IMPERIAL,
  lengthPrecision: 1,
};

export function unitsSettingsKey(projectId) {
  return `codiii-review-units:${projectId || 'default'}`;
}

export function loadUnitsSettings(projectId) {
  if (typeof localStorage === 'undefined') return { ...DEFAULTS };
  try {
    const raw = localStorage.getItem(unitsSettingsKey(projectId));
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveUnitsSettings(projectId, settings) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(unitsSettingsKey(projectId), JSON.stringify(settings));
  } catch {
    // quota
  }
}
